export default __webpack_public_path__ + "assets/niac-logo.a9985988.png";